import * as React from "react";
import { styled } from "@mui/system";

const NumberInput = React.forwardRef(function CustomNumberInput(
  { value, min, max, onInputChange,disabled, ...other },
  ref
) {
  return (
    <InputRoot ref={ref} {...other}>
      <InputElement
        type="number"
        value={value}
        onChange={onInputChange}
        min={min}
        max={max}
        disabled={disabled}
      />
    </InputRoot>
  );
});

export default function NumberInputAdornments({
  updateNumberInput,
  defaultValue,
  id,
  min,
  max,
  handleToast,
  disabled
}) {
  const [input, setInput] = React.useState(defaultValue);

  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    if (inputValue === "") {
      setInput("");
      updateNumberInput(id, null);
    } else {
      const value = Number(inputValue);
      updateNumberInput(id, value);
      setInput(value);

      if (value < min) {
        handleToast(id, -1);
      } else if (value > max) {
        handleToast(id, 1);
      }
    }
  };

  React.useEffect(() => {
    setInput(defaultValue);
  }, [defaultValue]);

  return (
    <NumberInput
      value={input}
      min={min}
      max={max}
      onInputChange={handleInputChange}
      sx={{
        height: "40px",
        "& .MuiNumberInput-input": {
          width: "100%",
        },
      }}
      disabled={disabled}
    />
  );
}

const InputRoot = styled("div")(
  ({ theme }) => `
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  line-height: 20px; 
  border-radius: 4px;
  color: ${theme.palette.mode === "dark" ? "#ccc" : "#333"};
  background: ${theme.palette.mode === "dark" ? "#333" : "#fff"};
  border: 1px solid #C4C4C4;
  // display: grid;
  grid-template-columns: auto 1fr;
  padding: 2px;
  overflow: hidden;
  &:hover {
    border-color: black;
  }

  &:focus-visible {
    outline: 0;
  }
`
);
const InputElement = styled("input")(
  ({ theme }) => `
  font-family: Poppins;
  font-size: 1rem;
  color: ${theme.palette.mode === "dark" ? "#ccc" : "#333"};
  background: inherit;
  border: none;
  border-radius: inherit;
  padding: 8px;
  outline: none;
  width: 100%;
  
  &:disabled {
    color: rgb(194, 194, 194); /* Text color for disabled input */
    background-color: ${theme.palette.mode === "dark" ? "#555" : "#f5f5f5"}; 
    cursor: not-allowed; /* Optional: indicate disabled state with cursor */
  }
`
);